<div class="catalog" data-test="catalog">
  <div class="spacing--padding-vertical">
    <app-catalog-category-selector></app-catalog-category-selector>
  </div>

  <app-catalog-products></app-catalog-products>
</div>
